import React, { useState, useEffect, useRef } from "react";
import { Header } from '../../Components/Layout/Header.jsx';
import { MetaTags } from '../../Components/Layout/MetaTags.jsx';
import { NavLink } from "react-router-dom";
import { NotFound } from '../../Pages/All/NotFound.jsx';
import Flickity from 'flickity';
import 'flickity/css/flickity.css';
import { Game } from "./Game.jsx"
function renderJackpotWins(item, index) {
    if (index < 5) {
        return (
            <div className="wins" key={index}>
                <div className="wins-row">
                    <div className="wins-row-container">
                        <div className="win-left">
                            <div className="win-time-and-date">{item.datumZaPrikaz}</div>
                            <div className="winner-name">{item.imeZaPrikaz}</div>
                        </div>
                        <div className="dobitak-iznos" >
                            <div className="iznos text-ellipsis">
                                {casino.utils.numberWithCurrencyFromated(item.dobitakPrikaz, "EUR")}</div>
                        </div>
                    </div>
                    <hr />
                </div>
            </div>
        )
    }
};

const FlickityCarouselGameScreenshots = ({ images, igra, brands }) => {
    const carouselRef = useRef(null);

    useEffect(() => {
        const flickityOptionsScreenShots = {
            cellAlign: 'left',
            fade: false,
            prevNextButtons: false,
            wrapAround: false,
            selectedAttraction: 1,
            friction: 1,
            imagesLoaded: true,
        };

        const flickityScreenshots = new Flickity(carouselRef.current, flickityOptionsScreenShots);

        return () => {
            flickityScreenshots.destroy();
        };
    }, [carouselRef]);
    return (
        <div key="carousel" ref={carouselRef} className="screenshots-carousel">
            {images.length > 0 ? images?.map((image, index) => (
                <div key={image} className="flickity-item">
                    <img src={`https://cdn.supersport.hr/Casino/GameInfoImages/${brands[igra?.bID]?.nameNormalizirano}/${image}` + '?c=' + casino.config.guiCacheVerzija} alt="Screenshots" />
                </div>
            )) : null}
        </div>
    );
};

// TODO: 
const FlickityCarouselSimilarGames = (props) => {
    const carouselGamesRef = useRef(null);

    useEffect(() => {
        const flickityOptionsGames = {
            draggable: true,
            prevNextButtons: false,
            cellAlign: 'left',
            fade: false,
            selectedAttraction: 1,
            friction: 0.5,
            wrapAround: true,
            imagesLoaded: true,
            pageDots: false,
            freeScroll: true
        };

        const flickityGames = new Flickity(carouselGamesRef.current, flickityOptionsGames);

        return () => {
            flickityGames.destroy();
        };
    }, [carouselGamesRef, props.similarGames]);

    return (
        <div key="similar_games" ref={carouselGamesRef} className="similar-games-carousel">
            {props && props.brands && props.gamecode && props.games?.items && props.similarGames?.map(similarGame => {
                var game = props.games.items.find(x => x.s === similarGame.sifraMobile && x.s != props.gamecode)
                if (game) {

                    return (
                        <div key={game.s} className="flickity-item">
                            <Game key={"game" + game.s} igra={game} brands={props.brands} />
                        </div>
                    )
                }
            })
            }
        </div>
    );
};

export default function GameInfo(props) {
    const [games, setGames] = useState([]);
    const [game, setGame] = useState("");
    const [gameInfo, setGameInfo] = useState(null);
    const [provider, setProvider] = useState("");
    const [button, setButton] = useState(true);
    const [igra, setIgra] = useState(null);
    const [opisList, setOpisList] = useState(null);
    const [loading, setLoading] = useState(true);
    const [faq, setFaq] = useState([]);

    useEffect(() => {
        extractSegmentsAndSetStates();
        getGamesFromRepo();
    }, []);

    useEffect(() => {
        getGameInfoFromRepo();
    }, [igra]);

    // get all data for the game
    useEffect(() => {
        if (games?.items) {
            const matchingIgra = games.items.find(item => casino.utils.normalizeString(item.n) === game);
            if (!matchingIgra) {
                props.showLoadingFn(true)
                setLoading(false)
            }
            setIgra(matchingIgra);
        }
    }, [games, game]);

    // get seo game information from repo
    const getGameInfoFromRepo = () => {
        if (igra) {
            casino.repos.seoGameInfoRepo.get(igra.s)
                .then(data => {
                    if (!data) {
                        props.showLoadingFn(true)
                    } else {
                        setGameInfo(data);
                        setOpisList(JSON.parse(data.opis))
                        props.showLoadingFn(false)
                        setLoading(false)
                        window.scrollTo(0, 0);
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        }

    };

    // get games from repo and store them in games state
    const getGamesFromRepo = () => {
        casino.repos.gameRepo.list()
            .then(data => {
                setGames(data);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    };

    const extractSegmentsAndSetStates = () => {
        if (props) {
            const urlSegments = props.route.location.pathname.split('/');
            const providerSegment = urlSegments[2];
            const gameSegment = urlSegments[3];

            setProvider(providerSegment);
            setGame(gameSegment);
        }
    };

    const startGameplay = (isDemo) => {
        const startedFrom = props.route.location.query && casino.utils.capitalizeFirstLetter(props.route.location.query.from);
        if (igra && casino.config.startGameInIframe) {
            const backUrl = casino.utils.getGameBackUrl(igra.id, props.selectedCategoryId, startedFrom);
            if (isDemo) {
                const gameUrl = casino.utils.getBaseUrl() + "gamelauncher/demo?id=" + igra.id + "&backUrl=" + backUrl;
                window.location.replace(gameUrl);
            } else {
                const gameUrl = casino.utils.getBaseUrl() + "gamelauncher/real?id=" + igra.id + "&backUrl=" + backUrl;
                window.location.replace(gameUrl);
            }
        } else {
            casino.repos.gameRepo.get(igra.id, isDemo, props.selectedCategoryId, startedFrom).then(startGame);
        }
    };

    const startGame = () => {
        props.showLoadingFn(false);
        window.location.replace(game.url);
    };

    // wins buttons
    const handleButtonClick = () => {
        setButton(!button);
    };

    const handleFaqOpenClose = (index) => {
        if (faq.includes(index)) {
            setFaq(faq.filter(x => x != index))
        }
        else {
            setFaq([...faq, index])
        }
    }

    const renderHamburgerPitanjeIOdgovor = (item, index) => {
        return (<div key={"pitanje-" + index} className={"faq-item" + (faq.includes(index) ? " active" : "")}>
            <div className="question-container" onClick={() => { handleFaqOpenClose(index) }}>
                <p className="question">{item.pitanje}</p>
                <button className="arrow-faq"></button>
            </div>
            <div className="">
                <ul className="answer">
                    <li dangerouslySetInnerHTML={{ __html: item.odgovor }}></li>
                </ul>
            </div>
        </div>)
    }

    // game + provider image url
    let gameImgUrl = game && provider && (casino.config.gameImagesUrl + provider + '/' + game + (casino.config.canIUseWebP ? '.webp' + '?c=' + casino.config.guiCacheVerzija : '.jpeg' + '?c=' + casino.config.guiCacheVerzija));

    let isDark = casino.utils.getCasinoTheme() === "dark";

    let providerImgUrl = provider && (casino.config.gameImagesUrl + provider + '/logos/logo' + (isDark ? "-dark" : "") + '.png' + '?c=' + casino.config.guiCacheVerzija);

    // render game info
    const renderGameInfo = (item, index) => {
        if (item.type === 1) {
            return (
                <div key={index}>
                    <div className="game-info">
                        <h2>{item.naslov}</h2>
                        <div dangerouslySetInnerHTML={{ __html: item.text }} />
                    </div>
                    <hr />
                </div>
            );
        } else if (item.type === 2) {
            return (
                <div key={index}>
                    <div className="game-images-container">
                        <h2>{item.naslov}</h2>
                        <FlickityCarouselGameScreenshots images={item.file} igra={igra} brands={props.brands} />
                    </div>
                    <hr className="hr-for-flickity" />
                </div>
            );
        }
        else if (item.type == 5) {
            var svaPitanja = [];
            svaPitanja.push(<h2 className="faq-h2">Često postavljena pitanja</h2>)
            for (var i = 0; i < item.hamburgerPitanja.length; i++) {
                svaPitanja.push(renderHamburgerPitanjeIOdgovor(item.hamburgerPitanja[i], i));
            }
            svaPitanja.push(<hr />)
            return svaPitanja;
        }

        else {
            return null;
        }
    };

    return (
        <>
            <MetaTags key="meta_tags" title="Promocije - SuperSport CASINO" description="Superbomba u SuperSport CASINU!" />
            <div key="wrapper" id="page-wrapper" className="no-padding white min-height-1000 game-info-wrapper">
                {!loading && opisList == null && <NotFound key="404-page" {...props} />}
                {!loading && opisList &&
                    <><Header key="header" {...props}></Header><div key="seo_game_info" className="seo-game-info-page">
                        <div onClick={() => location.href = 'https://mcasino.supersport.hr'} className="game-info-header">
                            <div className="back-button-small"><span className="back-icon" /></div>
                            {<h2>{igra?.n}</h2>}
                        </div>
                        <div className="game-image-large">
                            <img src={gameImgUrl} className="game-image" />
                        </div>
                        <div className="buttons-container">
                            <div className={props.userChecked ? 'button-switcher' : 'hidden'}>
                                <div className={props.user ? 'play-button' : 'hidden'}>
                                    <a onClick={() => startGameplay(false)}><span className="play-icon" />ZAIGRAJ</a>
                                </div>
                                <div className={!props.user ? 'login-button' : 'hidden'}>
                                    <NavLink to={{ pathname: "/login", state: { from: props.route.location } }}>ZAIGRAJ</NavLink>
                                </div>
                            </div>
                            <button className="try-button" onClick={() => startGameplay(true)}>ISPROBAJ</button>
                        </div>
                        {igra?.jp ?
                            <div className="jackpot-container">
                                <div className="jackpot-image"></div>
                                <div className="jackpot-amount" key={igra.id}>
                                    {casino.utils.numberToEuro2(igra.jp)}
                                </div>
                            </div>
                            : <div className="null" />}
                        <div className="provider-image-large">
                            <a href={provider === 'supercasino' ? 'Provideri?provider=superigre' : `Provideri?provider=${provider}`}>
                                <img src={providerImgUrl} className="provider-image" alt={provider} />
                            </a>
                        </div>
                    <hr />
                    {gameInfo?.datumUIVisible && <><div className="live-player-count-container">
                        <h3>Igra aktivna od:</h3>
                        <div className="active-from"><span className="active-from-icon"></span>{new Date(gameInfo.datumUIVisible).toLocaleDateString("hr-HR")} </div>
                    </div><div className="hr-with-padding">
                            <hr />
                        </div></>}
                        {gameInfo?.liveRTP > 0 && <><div className="live-player-count-container">
                            <h3>Live RTP</h3>
                            <div className="live-rtp"><span className="live-rtp-icon"></span>{gameInfo?.liveRTP}%</div>
                        </div><div className="hr-with-padding">
                                <hr />
                            </div></>}
                        {gameInfo?.brojIgraca > 0 && <><div className="live-player-count-container">
                            <h3>Broj igrača</h3>
                            <div className="live-player-count"><span className="player-icon"></span>{gameInfo?.brojIgraca}</div>
                        </div><div className="hr-with-padding">
                                <hr />
                            </div></>}
                        {gameInfo?.realRTP > 0 && <><div className="live-player-count-container">
                            <h3>Real RTP</h3>
                            <div className="real-rtp"><span className="real-rtp-icon"></span>{gameInfo?.realRTP}%</div>
                        </div><div className="hr-with-padding">
                                <hr />
                            </div></>}
                        {gameInfo?.volitility > 0 && <><div className="live-player-count-container">
                            <h3>Volatilnost</h3>
                            <div className="volitility"><span className="volitility-icon"></span>{gameInfo?.volitility}</div>
                        </div><div className="hr-with-padding">
                                <hr />
                            </div></>}
                        {gameInfo?.hitFrequency > 0 && <><div className="live-player-count-container">
                            <h3>Hit frequency</h3>
                            <div className="hit-frequency"><span className="hit-frequency-icon"></span>{gameInfo?.hitFrequency}%</div>
                        </div><div className="hr-with-padding">
                                <hr />
                        </div></>}

                        <div className="winners-container">
                            <div className="button-container">
                                <button className={`btn-left ${button ? 'btn-enabled' : 'btn-disabled'}`} onClick={handleButtonClick} disabled={button}>Najveći dobici</button>

                                <button className={`btn-right ${button ? 'btn-disabled' : 'btn-enabled'}`} onClick={handleButtonClick} disabled={!button}>Posljednji dobici</button>
                            </div>
                            <div className="null" />
                            {button && gameInfo?.najveciDobici?.map((item, index) => renderJackpotWins(item, index))}
                            {!button && gameInfo?.posljednjiDobici?.map((item, index) => renderJackpotWins(item, index))}
                        </div>
                        <hr />
                        <div className="game-info-container">
                            {opisList?.map((item, index) => renderGameInfo(item, index))}
                        </div>
                        {gameInfo?.similarGames.length != 0 && <div className="similar-games-container">
                            <h3>Zaigraj slične igre</h3>
                            <FlickityCarouselSimilarGames gamecode={gameInfo?.sifraIgre} similarGames={gameInfo?.similarGames} games={games} brands={props.brands} />
                        </div>}
                    </div></>
                }
            </div >
        </>
    );
};